
export default class HashScrolling {
    static init() {
        // scroll to hash on load
        window.addEventListener('load', () => {
            setTimeout(() => {
                HashScrolling.scrollToLinkHash(window.location.hash);
            }, 1000);
        });

        window.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            if (link && link.hash && link.href.replace(location.href.replace(location.hash, ''), '') === link.hash) {
                e.preventDefault();
                e.stopPropagation();
                HashScrolling.scrollToLinkHash(link.hash);
            }
        });
    }

    static _getScrollTop(targetElement) {
        const header = document.querySelector('header.header');
        return targetElement.getBoundingClientRect().top + window.scrollY - header.getBoundingClientRect().height - 10;
    }

    /**
     * @param hash hash or css query selector
     */
    static scrollToLinkHash(hash) {
        const targetElement = hash && document.querySelector(hash);
        HashScrolling.scrollToLink(targetElement);
    }


    static scrollToLink(targetElement) {
        if (!targetElement) return;

        let top = HashScrolling._getScrollTop(targetElement);
        window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: top,
        });

        // TODO Find better solution
        // header height changes, when it becomes fixed, so we need to re-ajust a bit
        setTimeout(() => {
            let top = HashScrolling._getScrollTop(targetElement);
            window.scrollTo({
                behavior: 'smooth',
                left: 0,
                top: top,
            });
        }, 300)
    }

    static scrollToLinkHashIfIsAbove(hash) {
        const targetElement = hash && document.querySelector(hash);
        HashScrolling.scrollToLinkIfIsAbove(targetElement);
    }

    static scrollToLinkIfIsAbove(targetElement) {
        if (!targetElement) return;

        if(HashScrolling._getScrollTop(targetElement) > window.scrollY) {
            HashScrolling.scrollToLink(targetElement);
        }
    }
}
